import { render, staticRenderFns } from "./TContactInfo.vue?vue&type=template&id=6aec22fc&scoped=true&"
import script from "./TContactInfo.vue?vue&type=script&lang=js&"
export * from "./TContactInfo.vue?vue&type=script&lang=js&"
import style0 from "./TContactInfo.vue?vue&type=style&index=0&id=6aec22fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aec22fc",
  null
  
)

/* custom blocks */
import block0 from "./TContactInfo.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports